import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnChanges,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { CommonUtil } from "../Utils/common-util";
import { IHaloDropDown } from "./halo-typeahead-dropdown.interface";

@Component({
  selector: "app-halo-typeahead-dropdown",
  templateUrl: "./halo-typeahead-dropdown.component.html",
  styleUrls: ["./halo-typeahead-dropdown.component.scss"]
})
export class HaloTypeAheadDropdownComponent implements OnInit, OnChanges {
  @Input() default: string;
  @Input() selectedForm: string | null;
  @Input() options: IHaloDropDown[];
  @Input() required:boolean;
  @Input() isAddEnabled = true;
  @Input() isSortEnabled = true;
  @Input() noBorderY = false;
  @Input() autoClear = false;
  @Input() placeHolderText = this.commonUtil.translateText('SEARCH.INSTRUCTOR.NAME');
  @Output() searchInputFocus = new EventEmitter();
  @Output() dropdownChange = new EventEmitter<IHaloDropDown | null>();
  @Output() addOption = new EventEmitter<string>();
  @Output() dropdownOnTouchChange = new EventEmitter();
  @ViewChild('filterInput') filterInput : ElementRef<HTMLInputElement>;

  isOpen: boolean = false;
  selected = "";
  searchInput = "";
  showAddRow = false;
  selectedOption: IHaloDropDown = {value:"",text:""};
  constructor(private eRef: ElementRef,private sanitizer: DomSanitizer,private commonUtil: CommonUtil) { }

  ngOnInit() {
    this.selected = this.selected?this.selected:this.default;
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.selectedForm && changes.selectedForm.currentValue !== changes.selectedForm.previousValue){
      if(this.options && changes.selectedForm.currentValue){
        let idx = this.options.findIndex((val:any) => val.value.toString() === changes.selectedForm.currentValue.toString());
        if(idx > -1){
          this.selected = this.options[idx].text;
          this.searchInput = this.options[idx].text;
          this.selectedOption = this.options[idx];
          this.isOpen = false;
          this.dropdownChange.emit(this.options[idx]);
        }       
      }
    }

    if(changes.default && changes.default.currentValue !== changes.default.previousValue){
      if(this.options  && changes.default.currentValue){
        let idx = this.options.findIndex((val:any) => val.value.toString() === changes.default.currentValue.toString());
        if(idx > -1){
          this.selected = this.options[idx].text;
          this.searchInput = this.options[idx].text;
          this.dropdownChange.emit(this.options[idx]);
        }
      }
    }

    if(changes.options && changes.options.currentValue !== changes.options.previousValue){
      this.options = changes.options.currentValue;
      if(this.selectedForm && changes.options.currentValue){
        this.options = changes.options.currentValue;
        let idx = this.options.findIndex((val:any) => val.value.toString() === this.selectedForm?.toString());
        if(idx > -1){
          this.selected = this.options[idx].text;
          this.searchInput = this.options[idx].text;
          this.selectedOption = this.options[idx];
          this.isOpen = false;
          this.dropdownChange.emit(this.options[idx]);
        } 
      }
    }
  }

  onSelect(option:IHaloDropDown) {
    this.selected = option ? option.text : this.default;
    this.searchInput = option ? option.text : this.default;
    this.selectedOption = option;
    this.dropdownChange.emit(this.selectedOption);
    this.dropdownOnTouchChange.emit();
    this.isOpen = false;
    if(this.autoClear) {
      this.onClear();
    }
  }

  onAdd(){
    this.dropdownOnTouchChange.emit();
    this.addOption.emit(this.searchInput);
  }
  
  onClear(){
    this.selectedForm = "";
    this.selected = "";
    this.searchInput = "";
    this.selectedOption = {value:"",text:""};
    this.dropdownChange.emit(this.selectedOption);   
    this.dropdownOnTouchChange.emit();
  }

  highlight(option: IHaloDropDown) {
    if (!this.searchInput) {
      return option.text;
    }

    return option.text.replace(new RegExp(this.searchInput, 'gi'), match => {
      return '<span style="font-weight:700;font-size:14px">' + match + '</span>';
    });
  }

  onSearchInputFocus($event:any){
    if(this.searchInput && this.selected){
      if(this.searchInput.toLowerCase() === this.selected.toLowerCase()){
        this.showAddRow = false;
      }    
    }
    this.isOpen = true;    
    this.searchInputFocus.emit();
    this.dropdownOnTouchChange.emit();
  }

  onSearchInputKeyUp(event:any){ 
    if(!this.isOpen){
      this.isOpen = true;
    }   
    let searchInputKeyWord = event.currentTarget.value;
    let status = this.options.findIndex(val => val.text.toLowerCase() === searchInputKeyWord.toLowerCase());  
    if(status>-1){
      this.showAddRow = false;
    }else{
      this.showAddRow = true;
    }  
  }

  onSearchInputKeydown(event:any){
    this.searchInput = this.searchInput? this.searchInput:"";
    this.selected = this.selected? this.selected: "";
    const isExist = this.options.findIndex((val:any) => val.text.trim().toLowerCase() === this.searchInput.trim().toLowerCase());
    if(this.searchInput && isExist === -1){
      this.addOption.emit(this.searchInput);
    } 
  }

  onSearchInputBlur(event:any){   
    setTimeout(() => {
      this.isOpen = false;
      this.showAddRow = false;
      this.searchInput = this.searchInput?this.searchInput:"";
      this.selected = this.selected?this.selected:"";
      if((!this.searchInput && this.selected) || (this.searchInput.toLowerCase() !== this.selected.toLowerCase())){        
        this.searchInput = this.selected;
       
      }else if(this.searchInput !== this.selected){        
        this.searchInput = "";
      }        
      this.dropdownChange.emit(this.selectedOption);
    },200);    
  }

  onClickCaret(){
    this.isOpen = !this.isOpen;
    if(this.searchInput && this.selected){
      if(this.searchInput.toLowerCase() === this.selected.toLowerCase()){
        this.showAddRow = false;
      }    
    }
    this.dropdownOnTouchChange.emit();
  }
}
